import styled from 'styled-components';

export const Container = styled.div<{}>`
  display: flex;
  flex-flow: row;
  column-gap: 10px;
  align-items: center;
`;

interface Props {
  checked?: boolean;
  label?: string;
  labelPosition?: string;
  disabled?: boolean;
  'data-testid'?: string;
}
export const StyledRadioButton = styled.input.attrs((props: Props) => ({
  ...props,
  type: 'radio',
}))`
  appearance: none;

  margin: 0;

  border-radius: 50%;
  width: 16px;
  height: 16px;

  border: 1px solid;
  border-color: ${(props) => props.theme.atlas.semantic.color.outline.default};
  transition: 0.2s border linear;

  &:checked {
    border: 4px solid;
    border-color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.default};
  }

  &:disabled {
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.disabled};
    border-color: ${(props) =>
      props.theme.atlas.semantic.color.ui.divider.default};
  }

  &:is(:disabled:checked) {
    background-color: unset;
    border-color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.default};
    opacity: 0.38;
  }
`;
